import { render } from "./UserReferrals.vue?vue&type=template&id=93c026bc"
import script from "./UserReferrals.vue?vue&type=script&lang=js"
export * from "./UserReferrals.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__